import { ConstantPool } from '@angular/compiler';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface SupportingDocument {
  id?: number;
  name: string;
  selected?: boolean;
  pageNo?: number;
  file?: File;
  url?: string;
}

@Component({
  selector: 'app-supported-document-modal',
  templateUrl: './supported-document-modal.component.html',
  styleUrls: ['./supported-document-modal.component.css'],
})
export class SupportedDocumentModalComponent {
  documents: SupportingDocument[] = [];
  mode: 'select' | 'upload' = 'select'; // 👈 new flag
  isLoading = true;

  constructor(
    private dialogRef: MatDialogRef<SupportedDocumentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    setTimeout(() => {
      this.mode = data.mode || 'select'; 
      const selectedDocs = data?.row?.supporting_documents || [];
      const selectedIds = selectedDocs.map((d: any) => d.id);

      this.documents = (data.documents || []).map((doc: any) => {
        const matched = selectedDocs.find((d: any) => d.id === doc.id);
        return {
          id: doc.id,
          name: doc.file_name,
          url: doc.file_url || doc.file,
          selected:
            this.mode === 'select' ? selectedIds.includes(doc.id) : true,
          pageNo: matched ? matched.page_reference : '',
        };
      });

      this.isLoading = false; // ✅ hide loader once data ready
    }, 300);
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    const selectedDocs =
      this.mode === 'select'
        ? this.documents.filter((d) => d.selected)
        : this.documents; // in upload mode, return all
    this.dialogRef.close(selectedDocs);
  }

  validatePageNo(doc: SupportingDocument) {
    if (doc.pageNo! < 0) doc.pageNo = 0;
  }

  handleAddDocumentClick(fileInput: HTMLInputElement) {
    fileInput.click();
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files) return;

    const uploadedFiles = Array.from(input.files);

    uploadedFiles.forEach((file) => {
      const existingDoc = this.documents.find(
        (doc) =>
          doc.name.trim().toLowerCase() === file.name.trim().toLowerCase()
      );

      if (existingDoc) {
        // ✅ Update existing doc file and mark as selected
        existingDoc.file = file;
        existingDoc.selected = true;
      } else {
        // ✅ Add new document and auto-select it
        this.documents.push({
          name: file.name,
          file,
          selected: true, // 👈 auto-selected
        });
      }
    });

    // Reset file input so same file can be re-added if needed
    input.value = '';
  }

  getTruncatedName(name: string) {
    return name.length > 15 ? name.slice(0, 15) + '...' : name;
  }

  getFileExtension(name: string) {
    const parts = name.split('.');
    return parts.length > 1 ? parts.pop() : '';
  }

  shouldShowTooltip(name: string) {
    return name.length > 15;
  }

  viewDocument(doc: SupportingDocument) {
    if (doc.file) {
      const fileURL = URL.createObjectURL(doc.file);
      window.open(fileURL, '_blank');
    } else if (doc.url) {
      window.open(doc.url, '_blank');
    }
  }
}
